import { render, staticRenderFns } from "./tourArea.vue?vue&type=template&id=f06f910e&scoped=true&"
import script from "./tourArea.vue?vue&type=script&lang=js&"
export * from "./tourArea.vue?vue&type=script&lang=js&"
import style0 from "./tourArea.vue?vue&type=style&index=0&id=f06f910e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f910e",
  null
  
)

export default component.exports